// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box":"box-UeB0fJwx clearfix","pic":"pic-1zRoVi-9","text":"text-12Nh_0S1","detail":"detail-17H1ZfU7"};